import {stripe} from 'services/stripe'
import {isWalletPaymentMethod} from 'utils/paymentMethodsHelpers'

import {
  PaymentMethod,
  PaymentMethodType
} from '@vio/core/src/api-types/bovio/response/payment_methods_settings'

import type {PaymentRequestOptions} from '@stripe/stripe-js'

export interface PaymentMethodConfiguration {
  type: PaymentMethodType
}
const PaymentMethodsMap = {
  applePay: PaymentMethodType.ApplePay,
  googlePay: PaymentMethodType.GooglePay
}

// Get a list of all available wallets; pings the Stripe API to check availability
export const getAvailableWallets = async (
  paymentRequestData: PaymentRequestOptions
): Promise<PaymentMethodConfiguration[]> => {
  try {
    const payments =
      await stripe.checkPaymentRequestAPIAvailability(paymentRequestData)

    return (Object.keys(payments) as Array<'applePay' | 'googlePay'>)
      .filter(payment => payments[payment] && PaymentMethodsMap[payment])
      .map(payment => ({type: PaymentMethodsMap[payment]}))
  } catch (error) {
    console.log('error payments :>>', error)
    return []
  }
}

const chargeLaterEnabledPaymentMethods = [PaymentMethodType.Card]
const getIsChargeLaterEnabledPaymentMethod = (
  paymentMethod: PaymentMethodType
) => {
  return chargeLaterEnabledPaymentMethods.includes(paymentMethod)
}

const getIsPiccEnabledPaymentMethod = (paymentMethod: PaymentMethodType) =>
  paymentMethod === PaymentMethodType.Card

export const isPaymentMethodSelectable = (
  paymentMethod: PaymentMethodType,
  isChargeLaterSelected: boolean,
  isCardCurrencySelected: boolean = false
) => {
  if (isCardCurrencySelected) {
    return getIsPiccEnabledPaymentMethod(paymentMethod)
  }

  if (getIsChargeLaterEnabledPaymentMethod(paymentMethod)) {
    return true
  } else {
    return !isChargeLaterSelected
  }
}

export const hasWalletPaymentMethod = (paymentMethods: PaymentMethod[]) =>
  paymentMethods.some(paymentMethod =>
    isWalletPaymentMethod(paymentMethod.type)
  )
